import { armorAPI } from '~/services/api';
import { type JSONTrackingConfig } from '~/types/TrackingSettings';

const fetchTrackingConfig = () =>
  armorAPI.request({
    method: 'GET',
    url: 'setting/tracking',
  });

const updateTrackingConfig = (payload: JSONTrackingConfig) =>
  armorAPI.request<JSONTrackingConfig>({
    data: payload,
    headers: {},
    method: 'POST',
    url: '/setting/tracking',
  });

export { fetchTrackingConfig, updateTrackingConfig };
